import React, { useState } from "react";
import { Button, Modal } from "antd";
import Barcode from "react-barcode";
import { useNavigate } from "react-router-dom";

const BarcodeModal = ({ item }) => {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [barcodeValue, setBarcodeValue] = useState("");

  const handleButtonClick = () => {
    const newBarcode = item?.BarCode;
    setBarcodeValue(newBarcode);

    // Show modal
    setIsModalVisible(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };

  return (
    <>
      <Button onClick={handleButtonClick}>Generate Label</Button>

      <Modal
        title="Generated Barcode"
        open={isModalVisible}
        onOk={handleOk}
        okText="Print"
        onCancel={handleCancel}
      >
        {barcodeValue && <Barcode value={barcodeValue} />}
        <p style={{ marginTop: "1rem" }}>Barcode: {barcodeValue}</p>
      </Modal>
    </>
  );
};

export default BarcodeModal;
